import React from 'react';
import i18n from "../../../i18next";
import { connect } from 'react-redux';
import { Container, Row, Col, Button, Modal, ModalHeader, ModalBody, Input } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import moment from 'moment/moment';


import CommonMessage from '../customerInsightScreen/CommonMessage';
import RestaurantInsightOptions from './RestaurantInsightOptions';
import { loadRestaurantInsight } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import { isUserMasterAdmin } from '../../../utils/CommonUtils';
import { enableDisableRestaurantInsight } from '../../../actions/restaurants/restaurantInsight/RestaurantInsightAction';
import TableCard from '../customerInsightScreen/TableCard';
import StatisticsPieChart from './StatisticsPieChart';
import GeneralStatistics from './GeneralStatistics';
import OrderFrequencyDetail from '../customerInsightScreen/OrderFrequencyDetail';
import StatisticsLineChart from './StatisticsLineChart';
import SectionTitle from '../customerInsightScreen/SectionTitle';
import CustomInsightsModal from '../customerInsightScreen/CustomInsightsModal';
import ProductSummarySearch from '../customerInsightScreen/ProductSummarySearch';
import PromotionSearchSelection from '../customerInsightScreen/PromotionSearchSelection';
import PromoCodesSummarySearch from './PromoCodesSummarySearch';
import OrderFrequencyHourSearch from '../customerInsightScreen/OrderFrequencyHourSearch';
import OrderFrequencyDaySearch from '../customerInsightScreen/OrderFrequencyDaySearch';
import OrderTypeSearch from '../customerInsightScreen/OrderTypeSearch';
import SourceTypeSearch from '../customerInsightScreen/SourceTypeSearch';
import PaymentTypeSearch from '../customerInsightScreen/PaymentTypeSearch';
class RestaurantInsightScreen extends React.Component {

    state = {
        isDisableInsightModalOpen: false,
        week: '0',
        isProductSummaryModalOpen: false,
        isPromotionModalOpen: false,
        isPromoCodesModalOpen: false,
        isOrderFrequencyHourModalOpen: false,
        isOrderFrequencyDayModalOpen: false,
        isOrderTypesModalOpen: false,
        isSourceTypesModalOpen: false,
        isPaymentTypesModalOpen: false
    }

    componentDidMount = () => {
        const { id } = this.props.match.params;

        this.props.loadRestaurantInsight(id);
    }

    toggleDisableModal = () => {
        this.setState({ isDisableInsightModalOpen: !this.state.isDisableInsightModalOpen })
    }

    togglePromotionModal = () => {
        this.setState({ isPromotionModalOpen: !this.state.isPromotionModalOpen })
    }

    togglePromoCodesModal = () => {
        this.setState({ isPromoCodesModalOpen: !this.state.isPromoCodesModalOpen })
    }

    toggleProductSummaryModal = () => {
        this.setState({ isProductSummaryModalOpen: !this.state.isProductSummaryModalOpen })
    }

    toggelOrderFrequencyHourModal = () => {
        this.setState({ isOrderFrequencyHourModalOpen: !this.state.isOrderFrequencyHourModalOpen })
    }

    toggelOrderFrequencyDayModal = () => {
        this.setState({ isOrderFrequencyDayModalOpen: !this.state.isOrderFrequencyDayModalOpen })
    }

    toggleOrderTypesModal = () => {
        this.setState({ isOrderTypesModalOpen: !this.state.isOrderTypesModalOpen })
    }

    toggleSourceTypesModal = () => {
        this.setState({ isSourceTypesModalOpen: !this.state.isSourceTypesModalOpen })
    }

    togglePaymentTypesModal = () => {
        this.setState({ isPaymentTypesModalOpen: !this.state.isPaymentTypesModalOpen })
    }

    disableInsights = () => {
        this.props.enableDisableRestaurantInsight(this.props.restaurantInsight.restaurantId, false)
        this.toggleDisableModal()
    }

    renderWeekOptions = () => {
        const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
        const weeks =  [lastWeekSummary, ...weekSummaries];
        moment.defaultFormat = "DD.MM.YYYY HH:mm";

        return weeks.map((week, i) => {
        return <option value={i}>{`${moment(week.fromDate, moment.defaultFormat).format('DD/MM/YYYY')}-${moment(week.toDate, moment.defaultFormat).format('DD/MM/YYYY')}`}</option>
    });
    }

    renderProductSummaryModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isProductSummaryModalOpen}
                onToggle={this.toggleProductSummaryModal}
                header={i18n.t('screens:customerInsightScreen.productSummary')}
            >
                <ProductSummarySearch restaurantId={this.props.match.params.id} insightType='restaurant'/>
            </CustomInsightsModal>
        )
    }

    renderPromotionModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isPromotionModalOpen}
                onToggle={this.togglePromotionModal}
                header={i18n.t('screens:customerInsightScreen.promotionSummary')}
            >
                <PromotionSearchSelection restaurantId={this.props.match.params.id} insightType='restaurant'/>
            </CustomInsightsModal>
        )
    }

    renderPromoCodesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isPromoCodesModalOpen}
                onToggle={this.togglePromoCodesModal}
                header={i18n.t('screens:restaurantInsightScreen.promoCodesSummary')}
            >
                <PromoCodesSummarySearch restaurantId={this.props.match.params.id} insightType='restaurant'/>
            </CustomInsightsModal>
        )
    }

    renderOrderFrequencyHourModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderFrequencyHourModalOpen}
                onToggle={this.toggelOrderFrequencyHourModal}
                header={i18n.t('screens:customerInsightScreen.orderFrequency')}
            >
                <OrderFrequencyHourSearch restaurantId={this.props.match.params.id} insightType='restaurant' />
            </CustomInsightsModal>
        )
    }

    renderOrderFrequencyDayModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderFrequencyDayModalOpen}
                onToggle={this.toggelOrderFrequencyDayModal}
                header={i18n.t('screens:customerInsightScreen.orderFrequency')}
            >
                <OrderFrequencyDaySearch restaurantId={this.props.match.params.id} insightType='restaurant' />
            </CustomInsightsModal>
        )
    }

    renderOrderTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isOrderTypesModalOpen}
                onToggle={this.toggleOrderTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersOrderType')}
            >
                <OrderTypeSearch restaurantId={this.props.match.params.id} insightType='restaurant' />
            </CustomInsightsModal>
        )
    }

    renderSourceTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isSourceTypesModalOpen}
                onToggle={this.toggleSourceTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersSourceType')}
            >
                <SourceTypeSearch restaurantId={this.props.match.params.id} insightType='restaurant' />
            </CustomInsightsModal>
        )
    }

    renderPaymentTypesModal = () => {
        return (
            <CustomInsightsModal
                isOpen={this.state.isPaymentTypesModalOpen}
                onToggle={this.togglePaymentTypesModal}
                header={i18n.t('screens:customerInsightScreen.ordersPaymentType')}
            >
                <PaymentTypeSearch restaurantId={this.props.match.params.id} insightType='restaurant' />
            </CustomInsightsModal>
        )
    }

    renderProductSummary = () => {
        const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
        const allWeeks = [lastWeekSummary, ...weekSummaries];
        const topProducts  = allWeeks[this.state.week].topProducts;
        
        return (
            <TableCard
                colSize={4}
                title={i18n.t('screens:restaurantInsightScreen.topProducts')}
                type="restaurantProducts"
                insightType='restaurant'
                content={topProducts}
                currency={this.props.restaurant.currency}
                toggleModal={this.toggleProductSummaryModal}
                chartType={topProducts.length > 0 && <StatisticsPieChart summary={topProducts} type="restaurantProducts" week={this.state.week}/>}
            />
        );
    }

    renderPromotionSummary = () => {
        const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
        const allWeeks = [lastWeekSummary, ...weekSummaries];
        const topPromotions  = allWeeks[this.state.week].topPromotions;

        return (
            <TableCard
                colSize={4}
                title={i18n.t('screens:restaurantInsightScreen.topPromotions')}
                type="restaurantPromotions"
                insightType='restaurant'
                content={topPromotions}
                currency={this.props.restaurant.currency}
                toggleModal={this.togglePromotionModal}
                chartType={topPromotions.length > 0 && <StatisticsPieChart summary={topPromotions} type="restaurantPromotions" week={this.state.week} />}
            />
        );
    }

    renderPromoCodesSummaries = () => {
        const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
        const allWeeks = [lastWeekSummary, ...weekSummaries];
        const topPromoCodes  = allWeeks[this.state.week].topPromoCodes;

       return (
           <TableCard
               colSize={4}
               title={i18n.t('screens:restaurantInsightScreen.topPromoCodes')}
               type="promoCodes"
               insightType='restaurant'
               content={topPromoCodes}
               currency={this.props.restaurant.currency}
               toggleModal={this.togglePromoCodesModal}
               chartType={topPromoCodes.length > 0 && <StatisticsPieChart summary={topPromoCodes} type="promoCodes" week={this.state.week} />}
           />
       );
   }

   renderOrderFrequencyDiagramByHour = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const allWeeks = [lastWeekSummary, ...weekSummaries];
    const ordersByHourSummaries  = allWeeks[this.state.week].ordersByHourSummaries;

    return (
        <React.Fragment>
                <OrderFrequencyDetail
                    colSize={12}
                    sectionTitle={i18n.t('screens:restaurantInsightScreen.orderFrequency')}
                    sectionTitleAddition={i18n.t('screens:restaurantInsightScreen.byTime')}
                    period="twoHourPeriod"
                    insightType="restaurant"
                    content={ordersByHourSummaries}
                    week={this.state.week}
                    toggleModal={this.toggelOrderFrequencyHourModal}
                />
        </React.Fragment>
    );
}

renderOrdersCountByWeekDiagram = () => {

    const { currentWeekRevenue, lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const ordersByWeek = [currentWeekRevenue, lastWeekSummary, ...weekSummaries];

    return (
        <React.Fragment>
            <OrderFrequencyDetail
                //colSize={12}
                sectionTitle={i18n.t('screens:restaurantInsightScreen.ordersCountByWeek')}
                period="week"
                insightType="restaurant"
                content={ordersByWeek}
                element='ordersCount'
            />
        </React.Fragment>
    );
}

renderTotalSpentByWeekDiagram = () => {
    const { currentWeekRevenue, lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const ordersByWeek = [currentWeekRevenue, lastWeekSummary, ...weekSummaries];
   
    return (
        <React.Fragment>
            <OrderFrequencyDetail
                //colSize={12}
                sectionTitle={i18n.t('screens:restaurantInsightScreen.totalSpentByWeek')}
                period="week"
                insightType="restaurant"
                content={ordersByWeek}
                element='ordersTotal'
                currency={this.props.restaurant.currency}
            />
        </React.Fragment>
    );
}

renderOrderFrequencyDiagramByDay = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const allWeeks = [lastWeekSummary, ...weekSummaries];
    const ordersByDaySummaries  = allWeeks[this.state.week].ordersByDaySummaries;

   return (
       <React.Fragment>
               <OrderFrequencyDetail
                   colSize={12}
                   sectionTitle={i18n.t('screens:restaurantInsightScreen.orderFrequency')}
                   sectionTitleAddition={i18n.t('screens:restaurantInsightScreen.byDay')}
                   period="day"
                   insightType="restaurant"
                   content={ordersByDaySummaries}
                   toggleModal={this.toggelOrderFrequencyDayModal}
               />
       </React.Fragment>
   );
}

renderPaymentTypeSummary = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const allWeeks = [lastWeekSummary, ...weekSummaries];
    const paymentTypeSummaries = allWeeks[this.state.week];;

    return (
        <TableCard
            //colSize={7}
            title={i18n.t('screens:customerInsightScreen.paymentType')}
            type="restaurantPaymentTypes"
            content={paymentTypeSummaries}
            currency={this.props.restaurant.currency}
            insightType="restaurant"
            toggleModal={this.togglePaymentTypesModal}
            chartType={<StatisticsLineChart summary={allWeeks} type="restaurantPaymentTypes"/>}
        />
    );
}

renderSourceTypeSummary = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const allWeeks = [lastWeekSummary, ...weekSummaries];
    const sourceTypeSummaries = allWeeks[this.state.week];

    return (
        <TableCard
            colSize={12}
            title={i18n.t('screens:customerInsightScreen.sourceType')}
            type="restaurantSourceTypes"
            insightType="restaurant"
            content={sourceTypeSummaries}
            currency={this.props.restaurant.currency}
            toggleModal={this.toggleSourceTypesModal}
            chartType={<StatisticsLineChart summary={allWeeks} type="restaurantSourceTypes"/>}
        />
    );
}

renderOrderTypeSummary = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const allWeeks = [lastWeekSummary, ...weekSummaries];
    const orderTypeSummaries = allWeeks[this.state.week];

    return (
        <TableCard
            colSize={12}
            title={i18n.t('screens:restaurantInsightScreen.orderType')}
            type="restaurantOrderTypes"
            content={orderTypeSummaries}
            currency={this.props.restaurant.currency}
            insightType="restaurant"
            week={this.state.week}
            toggleModal={this.toggleOrderTypesModal}
            chartType={<StatisticsLineChart summary={allWeeks} type="restaurantOrderTypes"/>}
        />
    );
}

renderSelectWeekDropDown = () => {
    const { lastWeekSummary, weekSummaries } = this.props.restaurantInsight;
    const weekSummary = [lastWeekSummary, ...weekSummaries];
    moment.defaultFormat = "DD.MM.YYYY HH:mm";

    return (
        <div style={{height: '40px', backgroundColor: 'white', marginLeft: '6%', display: 'flex', paddingBottom: '7px', alignItems: 'end', width: '77%', height: '100%'}}>
            <SectionTitle title={i18n.t('screens:restaurantInsightScreen.showingDataForPeriod')} />
            <Col>
                <Input type="select" name="week" id="week" value={this.state.week} onChange={(e) => this.setState({ week: e.target.value })} style={{height:'26px', fontSize: '11px', textAlign: 'center'}}>
                    {this.renderWeekOptions()}
                </Input>
            </Col>
        </div>
    )
}

renderEnabledData = () => {
        const { mainContainer, rowStyle } = styles;

        return (
            <React.Fragment>
                <Container fluid style={mainContainer}>
                    {this.renderDisableOptionAndWeekDropDown()}
                    <Row>
                        {<GeneralStatistics
                        currency={this.props.restaurant.currency}
                        />}
                    </Row>
                    <Row style={rowStyle}>
                        <Col style={{padding: '0px', marginTop: '5px'}}>
                            <Row style={{padding:'0px 41px 0px 41px'}}>
                                    {this.renderProductSummary()}
                                    {this.renderPromotionSummary()}
                                    {this.renderPromoCodesSummaries()}
                            </Row>
                    </Col>
                    </Row>
                    <Row style={{margin:'0px', display:'flex', padding:'0px 25px 0px 25px'}}>
                        <Col sm={6}>
                            <Row >
                                {this.renderOrderFrequencyDiagramByDay()}
                            </Row>
                        </Col>
                        <Col sm={6}>
                            <Row>
                                {this.renderOrderFrequencyDiagramByHour()}
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{margin:'0px', display:'flex', padding:'0px 25px 0px 25px'}}>
                        <Col sm={6}>
                            <Row >
                            {this.renderOrdersCountByWeekDiagram()}
                            </Row>
                        </Col>
                        <Col sm={6}>
                            <Row>
                                {this.renderTotalSpentByWeekDiagram()}
                            </Row>
                        </Col>
                    </Row>
                    <Row style={{margin:'0px', display:'flex', padding:'0px 25px 0px 25px'}}>
                        <Col sm={4}>
                            <Row>
                                {this.renderOrderTypeSummary()}
                            </Row>
                        </Col>
                        <Col sm={4}>
                            <Row>
                                {this.renderSourceTypeSummary()}
                            </Row>
                        </Col>
                        <Col sm={4}>
                            <Row>
                                {this.renderPaymentTypeSummary()}
                            </Row>
                        </Col>
                    </Row>
                </Container>
                {this.renderDisableInsightModal()}
                {this.renderProductSummaryModal()}
                {this.renderPromotionModal()}
                {this.renderPromoCodesModal()}
                {this.renderOrderFrequencyHourModal()}
                {this.renderOrderFrequencyDayModal()}
                {this.renderOrderTypesModal()}
                {this.renderSourceTypesModal()}
                {this.renderPaymentTypesModal()}
            </React.Fragment>

        );
    }

    renderDisableOptionAndWeekDropDown = () => {
        const { rowStyle, colContainerStyle } = styles;

        const user = this.props.currentlyLoggedInUser;

        if (!isUserMasterAdmin(user)) {
            return null;
        }

        return (
            <Row style={rowStyle}>
                <Col style={colContainerStyle}>
                    <Row style={{alignItmes: 'center', display: 'flex', justifyContent: 'space-between', maxWidth: '100%'}}>
                        <Col xs={4}>
                            {this.renderSelectWeekDropDown()}
                        </Col>
                        <Col xs={1}>
                            <Button color="primary" sm={12} onClick={this.toggleDisableModal} >
                            <MaterialIcon icon="remove_circle_outline" color="#fff" size={18} /> {i18n.t('common:buttons.disable')}
                            </Button>
                        </Col>
                    </Row>
                </Col>
            </Row >
        );
    }

    renderDisableInsightModal() {

        return (
            <Modal isOpen={this.state.isDisableInsightModalOpen} toggle={this.toggleDisableModal} size="md">
                <ModalHeader className="modalHeader" toggle={this.toggleDisableModal}>{i18n.t('screens:restaurantInsightScreen.disableInsightModalTitle')}</ModalHeader>
                <ModalBody>
                    <h6 style={{ marginBottom: 15 }} >{i18n.t('screens:restaurantInsightScreen.disableInsightModalMessage')}</h6>
                    <Button
                        style={{ marginRight: 10, position: 'relative' }}
                        color="primary"
                        onClick={this.disableInsights}
                    >
                        {i18n.t('common:buttons.confirm')}
                    </Button>
                    <Button onClick={this.toggleDisableModal}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalBody>
            </Modal>
        );
    }

    renderContent = () => {
        if (this.props.restaurantInsight.insightEnabled === null) {
            return null;
        } else if (!this.props.restaurantInsight.insightEnabled) {
            return <CommonMessage message={i18n.t('screens:restaurantInsightScreen.restaurantInsightDisabled')} />;
        } else {
            switch (this.props.restaurantInsight.status) {
                case "DISABLED":
                case "PLANNED":
                case "IN_PROGRESS":
                    return <RestaurantInsightOptions />
                case "ENABLED":
                    return this.renderEnabledData();
                default:
                    return null;
            }
        }
    }

    render() {
        return (
            this.renderContent()
        );
    }
}

const mapStateToProps = state => {
    return {
        restaurantInsight: state.restaurantInsight,
        restaurant: state.restaurant,
        currentlyLoggedInUser: state.user
    }
};

export default connect(mapStateToProps, { 
    loadRestaurantInsight, 
    enableDisableRestaurantInsight })(RestaurantInsightScreen);

const styles = {
    mainContainer: {
        backgroundColor: 'rgb(235,240,244)',
        padding: '0',
        marginTop: '10px'
    },
    rowStyle: {
        margin: '0',
        display: 'flex',
        justifyContent: 'space-evenly'
    },
    colContainerStyle: {
        padding: '10px 10px 0 10px',
        textAlign: 'right'
    }
};


// WEBPACK FOOTER //
// ./src/components/restaurants/restaurantInsight/RestaurantInsightScreen.js